// eslint-disable-next-line import/no-unresolved
import { set } from '@/utils/vuex';

const mutations = {
  metricsWithMetricTabs: set('metricsWithMetricTabs'),
};
export default mutations;
